import { render } from "./StudentProfile.vue?vue&type=template&id=6aadbae2&scoped=true"
import script from "./StudentProfile.vue?vue&type=script&lang=js"
export * from "./StudentProfile.vue?vue&type=script&lang=js"

import "./StudentProfile.vue?vue&type=style&index=0&id=6aadbae2&scoped=true&lang=css"

import exportComponent from "/app/code_base/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aadbae2"]])

export default __exports__